import { render } from "./NewMessageAudioRecorder.vue?vue&type=template&id=4b20b63f&scoped=true"
import script from "./NewMessageAudioRecorder.vue?vue&type=script&lang=js"
export * from "./NewMessageAudioRecorder.vue?vue&type=script&lang=js"

import "./NewMessageAudioRecorder.vue?vue&type=style&index=0&id=4b20b63f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b20b63f"]])

export default __exports__